export default "__VITE_ASSET__XSLOf$lH__"